<div class="userAds">

  <mat-button-toggle-group
   class="userAds__selectAdsStatus"
   *ngIf="!this.service.userService.isDemo()">
    <mat-button-toggle
      class="active"
      value="ACTIVE"
      (change)="setViewMode($event.value)"
      [checked]="this.viewModeIsActive()"
      >Active
    </mat-button-toggle>
    <mat-button-toggle
      class="expired"
      value="EXPIRED"
      (change)="setViewMode($event.value)"
      [checked]="this.viewModeIsExpired()"
      >Expired
    </mat-button-toggle>
  </mat-button-toggle-group>

    <div class="userAds__loader" *ngIf="advLoading"><mat-spinner diameter="60" ></mat-spinner></div>
    <div class="userAds__noResults" *ngIf="!advLoading && cardList.length<=0">0 results</div>

    <mat-list class="userAds__adsList"  role="list" *ngIf="!advLoading">
        <mat-list-item 
        class="adsItem userAds__adsItem"  
        role="listitem" 
        (click)="openAdv(card.advertisementId)" 
        *ngFor="let card of cardList">
            <div class="adsItem__img">
                <img [src]="getImageFromCard(card)" *ngIf="hasAdvertismentImage(card); else placeholderImage">
                <ng-template #placeholderImage><img src="assets/img/user_placeholder.png" /></ng-template>
            </div>
            <div  class="adsItem__content">
                <div class="adsItem__title">{{ getAdvTitle(card) }}</div>
                <div class="adsItem__city">{{ getLocation(card) }}</div>
            </div>
            <div class="adsItem__btGoToAd">
                <mat-icon aria-hidden="false" aria-label="search button">chevron_right</mat-icon>
            </div>
            <div class="adsItem__starWrap" *ngIf="getPremiumText(card) != '' && enableSubscription" (click)="showTip($event)">
                <i class="adsItem__starIcon material-icons">star</i>
                <span class="textTip adsItem__textTip">{{getPremiumText(card)}}</span>
            </div>
            <div class="adsItem__editWrap" (click)="editAdv(card.advertisementId)">
              <i class="adsItem__editIcon material-icons">edit</i>
          </div>   
        </mat-list-item>
    </mat-list>
    <div class="userAds__pagination" *ngIf="length > pageSize">   
        <mat-paginator 
         (page)="pageEvent = $event"
         [length]="length"
         [pageIndex]="pageNumber"
         [pageSize]="pageSize"
         [hidePageSize]="true"
        >
        </mat-paginator>
    </div> 
  </div>

